import PropTypes from 'prop-types';

const roles = PropTypes.shape({
  canCreate: PropTypes.bool,
  canModify: PropTypes.bool
});

const insuranceNetwork = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const insuranceNetworkContainer = {
  roles: roles.isRequired
};

export const insuranceNetworkList = {
  roles: roles.isRequired,
  currentInsuranceNetworks: PropTypes.array.isRequired,
  updateInsuranceNetwork: PropTypes.func.isRequired,
  deleteInsuranceNetwork: PropTypes.func.isRequired,
  selectedInsuranceNetwork: insuranceNetwork,
  setSelectedInsuranceNetwork: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  setShowCreateForm: PropTypes.func.isRequired
}

export const insuranceNetworkItem = {
  roles: roles.isRequired,
  insuranceNetwork: insuranceNetwork.isRequired,
  updateInsuranceNetwork: PropTypes.func.isRequired,
  deleteInsuranceNetwork: PropTypes.func.isRequired,
  setShowCreateForm: PropTypes.func.isRequired,
  selectedInsuranceNetwork: insuranceNetwork,
  setSelectedInsuranceNetwork: PropTypes.func.isRequired,
}

export const insuranceNetworkCreateForm = {
  showCreateForm: PropTypes.bool.isRequired,
  setShowCreateForm: PropTypes.func.isRequired,
  addInsuranceNetwork: PropTypes.func.isRequired
}

export const insuranceNetworkSearch = {
  roles: roles,
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.func.isRequired,
  showCreateForm: PropTypes.bool.isRequired,
  setShowCreateForm: PropTypes.func.isRequired,
  insuranceNetworks: PropTypes.array.isRequired,
  setCurrentInsuranceNetworks: PropTypes.func.isRequired,
  setSelectedInsuranceNetwork: PropTypes.func.isRequired
}
